var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoicemail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6263 4.89551C2.09797 4.89551 0.855469 6.13801 0.855469 7.66634L0.855469 9.99967C0.855469 10.8863 1.57297 11.6038 2.45964 11.6038H5.95964C6.1988 11.6038 6.39714 11.4055 6.39714 11.1663V7.66634C6.39714 6.13801 5.15464 4.89551 3.6263 4.89551Z",
    fill: "#2B2B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2091 4.02083C11.7691 4.02083 12.2299 3.56 12.2299 3V1.83333C12.2299 1.27333 11.7691 0.8125 11.2091 0.8125L8.87578 0.8125C8.31578 0.8125 7.85495 1.27333 7.85495 1.83333L7.85495 4.89583H5.98828C6.76995 5.56667 7.27161 6.55833 7.27161 7.66667L7.27161 11.1667C7.27161 11.3183 7.24245 11.4642 7.18995 11.6042H10.6258C11.5124 11.6042 12.2299 10.8867 12.2299 10L12.2299 7.66667C12.2299 6.13833 10.9874 4.89583 9.45911 4.89583L8.72995 4.89583V4.02083L11.2091 4.02083Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoicemail);
export default __webpack_public_path__ + "static/media/voicemail.582c16c04e52a2856be3993a3dfa0fae.svg";
export { ForwardRef as ReactComponent };